import React, { useState, useEffect } from "react";
import styled from "styled-components";

const ConsentBanner = styled.div<{ $show: boolean }>`
  position: fixed;
  bottom: ${(props) => (props.$show ? "0" : "-100%")};
  left: 0;
  right: 0;
  background: white;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
  padding: 1.5rem 2rem;
  z-index: 9999;
  transition: bottom 0.4s ease-in-out;
  border-top: 3px solid ${(props) => props.theme.colors.primary};

  @media (max-width: 768px) {
    padding: 1.25rem 1rem;
  }
`;

const ConsentContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
`;

const ConsentText = styled.p`
  color: ${(props) => props.theme.colors.text};
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column;
  }
`;

const AcceptButton = styled.button`
  background: ${(props) => props.theme.colors.primary};
  color: white;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: ${(props) => props.theme.shadows.light};

  &:hover {
    background: ${(props) => props.theme.colors.textWarm};
    box-shadow: ${(props) => props.theme.shadows.medium};
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 0.875rem;
  }
`;

const DeclineButton = styled.button`
  background: transparent;
  color: ${(props) => props.theme.colors.text};
  padding: 0.75rem 2rem;
  border: 2px solid ${(props) => props.theme.colors.border};
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.3s ease;

  &:hover {
    border-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.primary};
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 0.875rem;
  }
`;

const CONSENT_KEY = "cookie-consent";

const CookieConsent: React.FC = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check if user has already given consent
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      // Show banner after a short delay for better UX
      setTimeout(() => setShow(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setShow(false);
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, "declined");
    setShow(false);
  };

  return (
    <ConsentBanner $show={show}>
      <ConsentContent>
        <ConsentText>
          אתר זה משתמש בעוגיות (Cookies) כדי לשפר את חוויית הגלישה שלך ולספק שירות
          מיטבי. המשך גלישה באתר מהווה הסכמה לשימוש בעוגיות.
        </ConsentText>
        <ButtonGroup>
          <AcceptButton onClick={handleAccept}>אני מסכים/ה</AcceptButton>
          <DeclineButton onClick={handleDecline}>לא תודה</DeclineButton>
        </ButtonGroup>
      </ConsentContent>
    </ConsentBanner>
  );
};

export default CookieConsent;
